import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { resetAppStorageForLogout } from "../../utils/scopedStorage";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    resetAppStorageForLogout();

    toast.success("Logged out successfully!");
    navigate("/login");
  }, [navigate]);

  return null; // Nothing to render
};

export default Logout;
